import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { SFooter } from '@slg/web-customer-shared';
import appConfig from '@/appConfig';
import VueMarkdown from 'vue-markdown';
import { useStore, useRouteRef } from '@/composables';


const __default__ = {
  name: 'Footer',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isFooterFullyShow: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



const store = useStore();
const route = useRouteRef();

const isAuth = computed(() => store.getters['auth/getIsAuth']);
const getStrapiCoreMenu = computed(() => store.getters['common/getStrapiCoreMenu']);
const getStrapiCoreSettings = computed(() => store.getters['common/getStrapiCoreSettings']);

const getIsShownPrivacyPreferences = computed(() => appConfig.extendedCookieSupport);

const getPrivacyPolicyPage = computed(() => {
  if (route.value.params.lang === 'de') {
    return 'https://www.slg.lu/de/politique-de-confidentialite/';
  }

  if (route.value.params.lang === 'fr') {
    return 'https://www.slg.lu/politique-de-confidentialite/';
  }

  return 'https://www.slg.lu/en/politique-de-confidentialite/';
});

function generatePathFromRouter(name = '') {
  const { defaultLanguage } = appConfig;
  const lang = route.value.params.lang || defaultLanguage;
  return { name, params: { lang } };
}

const menuItems = computed(() => [
  {
    strapiText: '',
    strapiKey: 'homeTitle',
    isAnotherDomain: false,
    title: 'footer.home',
    path: generatePathFromRouter('Booking'),
  },
  {
    strapiText: '',
    strapiKey: 'FAQTitle',
    isAnotherDomain: false,
    title: 'footer.faq',
    path: generatePathFromRouter('FAQ'),
  },
  {
    strapiText: '',
    strapiKey: 'contactUsTitle',
    isAnotherDomain: false,
    title: 'footer.contactUs',
    path: generatePathFromRouter('ContactUs'),
  },
  {
    strapiText: '',
    isAnotherDomain: true,
    strapiKey: 'policyTitle',
    title: 'footer.privacyPolicy',
    path: { name: getPrivacyPolicyPage.value },
  },
  {
    strapiText: '',
    isAnotherDomain: false,
    strapiKey: 'termsTitle',
    title: 'footer.termsAndConditions',
    path: generatePathFromRouter('TermsAndConditions'),
  },
  {
    strapiText: '',
    isAnotherDomain: false,
    strapiKey: 'sitemapTitle',
    title: 'footer.sitemap',
    path: generatePathFromRouter('Sitemap'),
  },
]);

function openCookieDialog() {
  store.commit('common/changeCookieDialogOpenState', true);
}

return { __sfc: true,store, route, isAuth, getStrapiCoreMenu, getStrapiCoreSettings, getIsShownPrivacyPreferences, getPrivacyPolicyPage, generatePathFromRouter, menuItems, openCookieDialog, SFooter, VueMarkdown }
}

})